import {kSystemIcons} from "../../../constants/icons";

export default function GlossaryResearchModeIcon({isStrictMode}) {
    // Used in GlossaryResearchModeButton to display selected mode
    // icon

    // BUILD
    return (
        <i className="material-icons text-[14px] mb-[1px]">
            {isStrictMode ? kSystemIcons.lock : kSystemIcons.waves}
        </i>
    );
}